@use "@fukuri-admins/ui/layout" as *;

.container {
  display: flex;
  gap: spacing("12");
  align-items: flex-start;
  width: 100%;
  padding: spacing("8") spacing("12") spacing("8") spacing("8");
  background: background('Sky');
  border-radius: borderRadius('md');
}

.left {
  display: flex;
  flex: 1;
  gap: spacing("8");
  align-items: flex-start;
  min-width: 0;
}

.iconWrap {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 4px;
  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて Sky 色に上書きする
  color: text('Sky');

  svg {
    color: inherit;
  }
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.titleWrapper {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.title {
  @include typography('Jp/14_W6');
  color: text('High');
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.listItem {
  display: flex;
  gap: spacing("8");
  align-items: center;
  width: 100%;
}

.canIcon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて Teal 色に上書きする
  color: text('Teal');

  svg {
    color: inherit;
  }
}

.cannotIcon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて Red 色に上書きする
  color: text('Red');

  svg {
    color: inherit;
  }
}

.itemText {
  @include typography('Jp/14_W3');
  color: text('Low');
  flex: 1;
  min-width: 0;
}
